var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-start":"","wrap":""}},[_c('v-text-field',{attrs:{"name":_vm.filter.text,"label":_vm.filter.text,"value":_vm.value},on:{"input":_vm.setValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }